module.exports = __webpack_public_path__ + "static/media/Gumshoos_gaussian2.d7e558ac.png";